// 赛季季度类型
export const raceQuarterOptM = [
  { label: "第一赛季", value: 1, image: "m/homePage/d1sj-btn.png" },
  { label: "第二赛季", value: 2, image: "m/homePage/d2sj-btn.png" },
  { label: "第三赛季", value: 3, image: "m/homePage/d3sj-btn.png" },
  { label: "第四赛季", value: 4, image: "m/homePage/d4sj-btn.png" },
  { label: "第五赛季", value: 5, image: "m/homePage/d5sj-btn.png" },
  { label: "第六赛季", value: 6, image: "m/homePage/d6sj-btn.png" },
  { label: "第七赛季", value: 7, image: "m/homePage/d7sj-btn.png" },
  { label: "第八赛季", value: 8, image: "m/homePage/d8sj-btn.png" },
  { label: "第九赛季", value: 9, image: "m/homePage/d9sj-btn.png" },
  { label: "第十赛季", value: 10, image: "m/homePage/d10sj-btn.png" },
  { label: "2025赛季", value: 2025, image: "m/homePage/d2025sj-btn.png" },
  { label: "第十一赛季", value: 11, image: "m/homePage/d11sj-btn.png" },
];

// 组别类型
export const groupTypeOptM = [
  { label: "勇武组", value: 1, image: "m/yw.png" },
  { label: "纵横组 ", value: 2, image: "m/zh.png" },
  { label: "无极组", value: 3, image: "m/wj.png" },
];

// 赛季类型
export const raceTypeOptM = [
  { label: "积分赛", value: 1, image: "m/homePage/jf-btn.png" },
  { label: "淘汰赛", value: 2, image: "m/homePage/tt-btn.png" },
  { label: "冠军赛", value: 3, image: "m/homePage/gj-btn.png" },
];

// 赛季季度类型
export const raceQuarterOptPC = [
  { label: "第一赛季", value: 1, image: "pc/homePage/d1sj-btn.png" },
  { label: "第二赛季", value: 2, image: "pc/homePage/d2sj-btn.png" },
  { label: "第三赛季", value: 3, image: "pc/homePage/d3sj-btn.png" },
  { label: "第四赛季", value: 4, image: "pc/homePage/d4sj-btn.png" },
  { label: "第五赛季", value: 5, image: "pc/homePage/d5sj-btn.png" },
  { label: "第六赛季", value: 6, image: "pc/homePage/d6sj-btn.png" },
  { label: "第七赛季", value: 7, image: "pc/homePage/d7sj-btn.png" },
  { label: "第八赛季", value: 8, image: "pc/homePage/d8sj-btn.png" },
  { label: "第九赛季", value: 9, image: "pc/homePage/d9sj-btn.png" },
  { label: "第十赛季", value: 10, image: "pc/homePage/d10sj-btn.png" },
  { label: "2025赛季", value: 2025, image: "pc/homePage/d2025sj-btn.png" },
  { label: "第十一赛季", value: 11, image: "pc/homePage/d11sj-btn.png" },
];

// 组别类型
export const groupTypeOptPC = [
  { label: "勇武组", value: 1, image: "pc/homePage/yw.png" },
  { label: "纵横组 ", value: 2, image: "pc/homePage/zh.png" },
  { label: "无极组", value: 3, image: "pc/homePage/wj.png" },
];

// 赛季类型
export const raceTypeOptPC = [
  { label: "积分赛", value: 1, image: "pc/homePage/jf-btn.png" },
  { label: "淘汰赛", value: 2, image: "pc/homePage/tt-btn.png" },
  { label: "冠军赛", value: 3, image: "pc/homePage/gj-btn.png" },
];

// 积分赛
export const jfsTime = {
  1: "6月29日、7月1日、7月3日、7月6日 21:20",
  2: "9月3日、9月4日、9月5日 21:30",
  3: "11月5日、11月6日、11月7日 21:30",
  4: "1月14日、1月15日、1月16日21:30",
  5: "3月17日、3月18日、3月19日21:30",
  6: "6月16日、6月17日、6月18日21:30",
  7: "10月11日、10月13日、10月14日",
  8: "2月21日、2月23日、2月24日",
  9: "8月3日、8月4日、8月5日",
  10: "11月2日、11月3日、11月4日",
  11: "3月8日、3月9日、3月10日、3月13日",
};

// 淘汰赛-第几轮
export const raceRoundPC = {
  1: [
    {
      label: "第一轮初赛",
      date: 1688908800000,
      dateText: "7月9日 21:40",
      value: 1,
    },
    {
      label: "第一轮复活赛",
      date: 1688995200000,
      dateText: "7月10日 21:40",
      value: 2,
    },
    {
      label: "第二轮初赛",
      date: 1689081600000,
      dateText: "7月11日 21:40",
      value: 3,
    },
    {
      label: "第二轮复活赛",
      date: 1689340800000,
      dateText: "7月14日 21:40",
      value: 4,
    },
  ],
  2: [
    {
      label: "第一轮初赛",
      date: 1694232000000,
      dateText: "9月9日 12:30",
      value: 1,
    },
    {
      label: "第一轮复活赛",
      date: 1694250000000,
      dateText: "9月9日 17:00",
      value: 2,
    },
    {
      label: "第二轮初赛",
      date: 1694320200000,
      dateText: "9月10日 12:30",
      value: 3,
    },
    {
      label: "第二轮复活赛",
      date: 1694336400000,
      dateText: "9月10日 17:00",
      value: 4,
    },
  ],
  3: [
    {
      label: "第一轮初赛",
      date: 1699678800000,
      dateText: "11月11日 13:00",
      value: 1,
    },
    {
      label: "第一轮复活赛",
      date: 1699695000000,
      dateText: "11月11日 17:30",
      value: 2,
    },
    {
      label: "第二轮初赛",
      date: 1699765200000,
      dateText: "11月12日 13:00",
      value: 3,
    },
    {
      label: "第二轮复活赛",
      date: 1699781400000,
      dateText: "11月12日 17:30",
      value: 4,
    },
  ],
  4: [
    {
      label: "第一轮初赛",
      date: 1705726800000,
      dateText: "1月20日13:00",
      value: 1,
    },
    {
      label: "第一轮复活赛",
      date: 1705743000000,
      dateText: "1月20日17:30",
      value: 2,
    },
    {
      label: "第二轮初赛",
      date: 1705813200000,
      dateText: "1月21日13:00",
      value: 3,
    },
    {
      label: "第二轮复活赛",
      date: 1705829400000,
      dateText: "1月21日17:30",
      value: 4,
    },
  ],
  5: [
    {
      label: "第一轮初赛",
      date: 1711170000000,
      dateText: "3月23日13:00",
      value: 1,
    },
    {
      label: "第一轮复活赛",
      date: 1711186200000,
      dateText: "3月23日17:30",
      value: 2,
    },
    {
      label: "第二轮初赛",
      date: 1711256400000,
      dateText: "3月24日13:00",
      value: 3,
    },
    {
      label: "第二轮复活赛",
      date: 1711272600000,
      dateText: "3月24日17:30",
      value: 4,
    },
  ],
  6: [
    {
      label: "第一轮初赛",
      date: 1719032400000,
      dateText: "6月22日13:00",
      value: 1,
    },
    {
      label: "第一轮复活赛",
      date: 1719048600000,
      dateText: "6月22日17:30",
      value: 2,
    },
    {
      label: "第二轮初赛",
      date: 1719118800000,
      dateText: "6月23日13:00",
      value: 3,
    },
    {
      label: "第二轮复活赛",
      date: 1719135000000,
      dateText: "6月23日17:30",
      value: 4,
    },
  ],
  7: [
    {
      label: "第一轮初赛",
      date: 1729314000000,
      dateText: "10月19日13:00",
      value: 1,
    },
    {
      label: "第一轮复活赛",
      date: 1729330200000,
      dateText: "10月19日17:30",
      value: 2,
    },
    {
      label: "第二轮初赛",
      date: 1729400400000,
      dateText: "10月20日13:00",
      value: 3,
    },
    {
      label: "第二轮复活赛",
      date: 1729416600000,
      dateText: "10月20日17:30",
      value: 4,
    },
  ],
  8: [
    {
      label: "第一轮初赛",
      date: 1740805200000, // new Date('2025-3-1 13:00').getTime()
      dateText: "3月1日13:00",
      value: 1,
    },
    {
      label: "第一轮复活赛",
      date: 1740805200000, // new Date('2025-3-1 17:30').getTime()
      dateText: "3月1日17:30",
      value: 2,
    },
    {
      label: "第二轮初赛",
      date: 1740805200000, // new Date('2025-3-2 13:00').getTime()
      dateText: "3月2日13:00",
      value: 3,
    },
    {
      label: "第二轮复活赛",
      date: 1740805200000, // new Date('2025-3-2 17:30').getTime()
      dateText: "3月2日17:30",
      value: 4,
    },
  ],
  9: [
    {
      label: "第一轮初赛",
      date: 1755320400000, // new Date('2025-8-16 13:00').getTime()
      dateText: "8月16日13:00",
      value: 1,
    },
    {
      label: "第一轮复活赛",
      date: 1755336600000, // new Date('2025-8-16 17:30').getTime()
      dateText: "8月16日17:30",
      value: 2,
    },
    {
      label: "第二轮初赛",
      date: 1755406800000, // new Date('2025-8-17 13:00').getTime()
      dateText: "8月17日13:00",
      value: 3,
    },
    {
      label: "第二轮复活赛",
      date: 1755423000000, // new Date('2025-8-17 17:30').getTime()
      dateText: "8月17日17:30",
      value: 4,
    },
  ],
  10: [
    {
      label: "第一轮初赛",
      date: 1731571200000, // new Date('2025-11-15 13:00').getTime()
      dateText: "11月15日13:00",
      value: 1,
    },
    {
      label: "第一轮复活赛",
      date: 1731587400000, // new Date('2025-11-15 17:30').getTime()
      dateText: "11月15日17:30",
      value: 2,
    },
    {
      label: "第二轮初赛",
      date: 1731657600000, // new Date('2025-11-16 13:00').getTime()
      dateText: "11月16日13:00",
      value: 3,
    },
    {
      label: "第二轮复活赛",
      date: 1731673800000, // new Date('2025-11-16 17:30').getTime()
      dateText: "11月16日17:30",
      value: 4,
    },
  ],
  11: [
    {
      label: "第一轮初赛",
      date: 1773464400000, // new Date('2026-3-14 13:00').getTime()
      dateText: "3月14日13:00",
      value: 1,
    },
    {
      label: "第一轮复活赛",
      date: 1773480600000, // new Date('2026-3-14 17:30').getTime()
      dateText: "3月14日17:30",
      value: 2,
    },
    {
      label: "第二轮初赛",
      date: 1773547200000, // new Date('2026-3-15 13:00').getTime()
      dateText: "3月15日13:00",
      value: 3,
    },
    {
      label: "第二轮复活赛",
      date: 1773563400000, // new Date('2026-3-15 17:30').getTime()
      dateText: "3月15日17:30",
      value: 4,
    },
  ]
};

// 冠军赛-进程
export const championshipPC = {
  1: [
    {
      label: "64进16",
      startDate: 1689508800000,
      endDate: 1689681600000,
      dateText: "7月16日、7月18日 20:00",
      value: 0,
    },
    {
      label: "16进4",
      startDate: 1689940800000,
      endDate: 1690113600000,
      dateText: "7月21日、7月23日 20:00",
      value: 1,
    },
    {
      label: "总决赛",
      startDate: 1690286400000,
      endDate: 1690718400000,
      dateText: [
        "7月25日、7月28日、7月29日", // 勇武组
        "7月25日、7月28日、7月30日", // 纵横组
        "7月25日、7月28日、7月30日", // 无极组
      ],
      sqDateText: [
        "7月25日 20:00", // 勇武组
        "7月25日 20:00", // 纵横组
        "7月25日 20:00", // 无极组
      ],
      jjDateText: [
        "7月28日 20:00", // 勇武组
        "7月28日 20:00", // 纵横组
        "7月28日 20:00", // 无极组
      ],
      fullDateText: [
        "7月29日13:30", // 勇武组
        "7月30日13:30", // 纵横组
        "7月30日20:00", // 无极组
      ],
      value: 2,
    },
  ],
  2: [
    {
      label: "64进16",
      startDate: 1694361600000,
      endDate: 1694448000000,
      dateText: "9月11日、9月12日 20:00",
      value: 0,
    },
    {
      label: "16进4",
      startDate: 1694707200000,
      endDate: 1694793600000,
      dateText: "9月15日20:00、9月16日12:30",
      value: 1,
    },
    {
      label: "总决赛",
      startDate: 1694880000000,
      endDate: 1695484800000,
      dateText: [
        "9月17日-9月24日", // 勇武组
        "9月17日-9月24日", // 纵横组
        "9月17日-9月24日", // 无极组
      ],
      sqDateText: [
        "9月17日 12:30", // 勇武组
        "9月17日 12:30", // 纵横组
        "9月17日 12:30", // 无极组
      ],
      jjDateText: [
        "9月22日 20:00", // 勇武组
        "9月22日 20:00", // 纵横组
        "9月22日 20:00", // 无极组
      ],
      fullDateText: [
        "9月23日 12:30", // 勇武组
        "9月24日 12:30", // 纵横组
        "9月24日 17:00", // 无极组
      ],
      value: 2,
    },
  ],
  3: [
    {
      label: "64进16",
      startDate: 1699876800000,
      endDate: 1699963200000,
      dateText: "11月13日、11月14日 20:00",
      value: 0,
    },
    {
      label: "16进4",
      startDate: 1700222400000,
      endDate: 1700308800000,
      dateText: "11月17日20:00、11月18日13:00",
      value: 1,
    },
    {
      label: "总决赛",
      startDate: 1700370000000, //  开始时间
      endDate: 1700991000000, // 结束时间
      dateText: [
        "11月19日-11月26日", // 勇武组
        "11月19日-11月26日", // 纵横组
        "11月19日-11月26日", // 无极组
      ],
      sqDateText: [
        "11月19日 13:00", // 勇武组
        "11月19日 13:00", // 纵横组
        "11月19日 13:00", // 无极组
      ],
      jjDateText: [
        "11月24日 20:00", // 勇武组
        "11月24日 20:00", // 纵横组
        "11月24日 20:00", // 无极组
      ],
      fullDateText: [
        "11月25日 13:00", // 勇武组
        "11月26日 13:00", // 纵横组
        "11月26日 17:30", // 无极组
      ],
      value: 2,
    },
  ],
  4: [
    {
      label: "64进16",
      startDate: 1705924800000,
      endDate: 1706011200000,
      dateText: "1月22日-1月23日20:00",
      value: 0,
    },
    {
      label: "16进4",
      startDate: 1706270400000,
      endDate: 1706331600000,
      dateText: "1月26日20:00、1月27日13:00",
      value: 1,
    },
    {
      label: "总决赛",
      startDate: 1706418000000,
      endDate: 1707039000000,
      dateText: [
        "1月28日-2月4日", // 勇武组
        "1月28日-2月4日", // 纵横组
        "1月28日-2月4日", // 无极组
      ],
      sqDateText: [
        "1月28日 13:00", // 勇武组
        "1月28日 13:00", // 纵横组
        "1月28日 13:00", // 无极组
      ],
      jjDateText: [
        "2月2日 20:00", // 勇武组
        "2月2日 20:00", // 纵横组
        "2月2日 20:00", // 无极组
      ],
      fullDateText: [
        "2月3日 13:00", // 勇武组
        "2月4日 13:00", // 纵横组
        "2月4日 17:30", // 无极组
      ],
      value: 2,
    },
  ],
  5: [
    {
      label: "64进16",
      startDate: 1711368000000,
      endDate: 1711454400000,
      dateText: "3月25日-3月26日20:00",
      value: 0,
    },
    {
      label: "16进4",
      startDate: 1711713600000,
      endDate: 1711774800000,
      dateText: "3月29日20:00、0日13:00",
      value: 1,
    },
    {
      label: "总决赛",
      startDate: 1711861200000,
      endDate: 1712482200000,
      dateText: [
        "3月31日-4月7日", // 勇武组
        "3月31日-4月7日", // 纵横组
        "3月31日-4月7日", // 无极组
      ],
      sqDateText: [
        "3月31日 13:00", // 勇武组
        "3月31日 13:00", // 纵横组
        "3月31日 13:00", // 无极组
      ],
      jjDateText: [
        "4月5日 20:00", // 勇武组
        "4月5日 20:00", // 纵横组
        "4月5日 20:00", // 无极组
      ],
      fullDateText: [
        "4月6日 13:00", // 勇武组
        "4月7日 13:00", // 纵横组
        "4月7日 17:30", // 无极组
      ],
      value: 2,
    },
  ],
  6: [
    {
      label: "64进16",
      startDate: 1719230400000,
      endDate: 1719316800000,
      dateText: "6月24日、6月25日20:00",
      value: 0,
    },
    {
      label: "16进4",
      startDate: 1719576000000,
      endDate: 1719637200000,
      dateText: "6月28日20:00、6月29日13:00",
      value: 1,
    },
    {
      label: "总决赛",
      startDate: 1719723600000,
      endDate: 1720344600000,
      dateText: [
        "6月30日-7月7日", // 勇武组
        "6月30日-7月7日", // 纵横组
        "6月30日-7月7日", // 无极组
      ],
      sqDateText: [
        "6月30日 13:00", // 勇武组
        "6月30日 13:00", // 纵横组
        "6月30日 13:00", // 无极组
      ],
      jjDateText: [
        "7月5日 20:00", // 勇武组
        "7月5日 20:00", // 纵横组
        "7月5日 20:00", // 无极组
      ],
      fullDateText: [
        "7月6日 13:00", // 勇武组
        "7月7日 13:00", // 纵横组
        "7月7日 17:30", // 无极组
      ],
      value: 2,
    },
  ],
  7: [
    {
      label: "64进16",
      startDate: 1729512000000,
      endDate: 1729598400000,
      dateText: "10月21日、10月22日20:00",
      value: 0,
    },
    {
      label: "16进4",
      startDate: 1729857600000,
      endDate: 1729944000000,
      dateText: "10月25日、10月26日20:00",
      value: 1,
    },
    {
      label: "总决赛",
      startDate: 1730005200000,
      endDate: 1730610000000,
      dateText: [
        "10月27日-11月3日", // 勇武组
        "10月27日-11月3日", // 纵横组
        "10月27日-11月3日", // 无极组
      ],
      sqDateText: [
        "10月27日 13:00", // 勇武组
        "10月27日 13:00", // 纵横组
        "10月27日 13:00", // 无极组
      ],
      jjDateText: [
        "11月1日 20:00", // 勇武组
        "11月1日 20:00", // 纵横组
        "11月1日 20:00", // 无极组
      ],
      fullDateText: [
        "11月2日 13:00", // 勇武组
        "11月3日 13:00", // 纵横组
        "11月3日 17:30", // 无极组
      ],
      value: 2,
    },
  ],
  8: [
    {
      label: "64进16",
      startDate: 1741003200000, // new Date('2025-3-3 20:00').getTime()
      endDate: 1741089600000, // new Date('2025-3-4 20:00').getTime()
      dateText: "3月3日、3月4日20:00",
      value: 0,
    },
    {
      label: "16进4",
      startDate: 1741410000000, // new Date('2025-3-8 13:00').getTime()
      endDate: 1741496400000, // new Date('2025-3-9 13:00').getTime()
      dateText: "3月8日、3月9日13:00",
      value: 1,
    },
    {
      label: "总决赛",
      startDate: 1742014800000, //  开始时间 new Date('2025-3-15 13:00').getTime()
      endDate: 1742731200000, // 结束时间 new Date('2025-3-23 20:00').getTime()
      dateText: [
        "3月15日-3月23日", // 勇武组
        "3月15日-3月23日", // 纵横组
        "3月15日-3月23日", // 无极组
      ],
      sqDateText: [
        "3月15日 13:00", // 勇武组
        "3月15日 13:00", // 纵横组
        "3月15日 13:00", // 无极组
      ],
      jjDateText: [
        "3月16日 13:00", // 勇武组
        "3月16日 13:00", // 纵横组
        "3月16日 13:00", // 无极组
      ],
      fullDateText: [
        "3月16日 20:00", // 勇武组 new Date('2025-3-16 20:00').getTime()
        "3月22日 13:00", // 纵横组 new Date('2025-3-22 13:00').getTime()
        "3月23日 20:00", // 无极组 new Date('2025-3-23 20:00').getTime()
      ],
      value: 2,
    },
  ],
  9: [
    {
      label: "64进16",
      startDate: 1755523800000, // new Date('2025-8-18 21:30').getTime()
      endDate: 1755610200000, // new Date('2025-8-19 21:30').getTime()
      dateText: "8月18日、8月19日21:30",
      value: 0,
    },
    {
      label: "16进4",
      startDate: 1755925200000, // new Date('2025-8-23 13:00').getTime()
      endDate: 1756011600000, // new Date('2025-8-24 13:00').getTime()
      dateText: "8月23日、8月24日13:00",
      value: 1,
    },
    {
      label: "总决赛",
      startDate: 1756530000000, //  开始时间 new Date('2025-8-30 13:00').getTime()
      endDate: 1757246400000, // 结束时间 new Date('2025-9-7 20:00').getTime()
      dateText: [
        "8月30日-9月7日", // 勇武组
        "8月30日-9月7日", // 纵横组
        "8月30日-9月7日", // 无极组
      ],
      sqDateText: [
        "8月30日 13:00", // 勇武组
        "8月30日 13:00", // 纵横组
        "8月30日 13:00", // 无极组
      ],
      jjDateText: [
        "8月31日 13:00", // 勇武组
        "8月31日 13:00", // 纵横组
        "8月31日 13:00", // 无极组
      ],
      fullDateText: [
        "8月31日 20:00", // 勇武组 new Date('2025-8-31 20:00').getTime()
        "9月6日 13:00", // 纵横组 new Date('2025-9-6 13:00').getTime()
        "9月7日 13:00", // 无极组 new Date('2025-9-7 13:00').getTime()
      ],
      value: 2,
    },
  ],
  10: [
    {
      label: "64进16",
      startDate: 1763386200000, // new Date('2025-11-17 21:30').getTime()
      endDate: 1763472600000, // new Date('2025-11-18 21:30').getTime()
      dateText: "11月17日、11月18日21:30",
      value: 0,
    },
    {
      label: "16进4",
      startDate: 1763787600000, // new Date('2025-11-22 13:00').getTime()
      endDate: 1763874000000, // new Date('2025-11-23 13:00').getTime()
      dateText: "11月22日、11月23日13:00",
      value: 1,
    },
    {
      label: "总决赛",
      startDate: 1764392400000, //  开始时间 new Date('2025-11-29 13:00').getTime()
      endDate: 1765083600000, // 结束时间 new Date('2025-12-7 13:00').getTime()
      dateText: [
        "11月29日-12月7日", // 勇武组
        "11月29日-12月7日", // 纵横组
        "11月29日-12月7日", // 无极组
      ],
      sqDateText: [
        "11月29日13:00", // 勇武组
        "11月29日13:00", // 纵横组
        "11月29日13:00", // 无极组
      ],
      jjDateText: [
        "11月30日13:00", // 勇武组
        "11月30日13:00", // 纵横组
        "11月30日13:00", // 无极组
      ],
      fullDateText: [
        "11月30日20:00", // 勇武组 new Date('2025-11-30 20:00').getTime()
        "12月6日13:00", // 纵横组 new Date('2025-12-6 13:00').getTime()
        "12月7日13:00", // 无极组 new Date('2025-12-7 13:00').getTime()
      ],
      value: 2,
    },
  ],
  2025: [
    {
      label: "64进16",
      startDate: 1765429200000, // new Date('2025-12-11 13:00').getTime()
      endDate: 1765515600000, // new Date('2025-12-12 13:00').getTime()
      dateText: "--",
      value: 0,
    },
    {
      label: "16进4",
      startDate: 1765602000000, // new Date('2025-12-13 13:00').getTime()
      endDate: 1765688400000, // new Date('2025-12-14 13:00').getTime()
      dateText: "12月13日、12月14日13:00",
      value: 1,
    },
    {
      label: "总决赛",
      startDate: 1766206800000, //  开始时间 new Date('2025-12-20 13:00').getTime()
      endDate: 1766811600000, // 结束时间 new Date('2025-12-27 13:00').getTime()
      dateText: [
        "12月20日-12月27日", // 勇武组
        "12月20日-12月27日", // 纵横组
        "12月20日-12月27日", // 无极组
      ],
      sqDateText: [
        "12月20日13:00", // 勇武组
        "12月20日13:00", // 纵横组
        "12月20日13:00", // 无极组
      ],
      jjDateText: [
        "12月21日13:00", // 勇武组
        "12月21日13:00", // 纵横组
        "12月21日13:00", // 无极组
      ],
      fullDateText: [
        "12月26日13:00", // 勇武组 new Date('2025-12-26 13:00').getTime()
        "12月26日18:30", // 纵横组 new Date('2025-12-26 18:30').getTime()
        "12月27日13:00", // 无极组 new Date('2025-12-27 13:00').getTime()
      ],
      value: 2,
    },
  ],
  11: [
    {
      label: "64进16",
      startDate: 1773667800000, // new Date('2026-3-16 21:30').getTime()
      endDate: 1773754200000, // new Date('2026-3-17 21:30').getTime()
      dateText: "3月16日、3月17日21:30",
      value: 0,
    },
    {
      label: "16进4",
      startDate: 1774182000000, // new Date('2026-3-21 13:00').getTime()
      endDate: 1774268400000, // new Date('2026-3-22 13:00').getTime()
      dateText: "3月21日、3月22日13:00",
      value: 1,
    },
    {
      label: "总决赛",
      startDate: 1774875600000, //  开始时间 new Date('2026-3-28 13:00').getTime()
      endDate: 1775480400000, // 结束时间 new Date('2026-4-12 13:00').getTime()
      dateText: [
        "3月28日-4月12日", // 勇武组
        "3月28日-4月12日", // 纵横组
        "3月28日-4月12日", // 无极组
      ],
      sqDateText: [
        "3月28日13:00", // 勇武组
        "3月28日13:00", // 纵横组
        "3月28日13:00", // 无极组
      ],
      jjDateText: [
        "3月29日13:00", // 勇武组
        "3月29日13:00", // 纵横组
        "3月29日13:00", // 无极组
      ],
      fullDateText: [
        "3月29日20:00", // 勇武组 new Date('2026-3-29 20:00').getTime()
        "4月11日13:00", // 纵横组 new Date('2026-4-11 13:00').getTime()
        "4月12日13:00", // 无极组 new Date('2026-4-12 13:00').getTime()
      ],
      value: 2,
    },
  ]
};

// 冠军赛时间
export const championRaceTime = {
  1: [
    { label: "勇武组", value: 1, time: 1690612200000 },
    { label: "纵横组 ", value: 2, time: 1690698600000 },
    { label: "无极组", value: 3, time: 1690723800000 },
  ],
  2: [
    { label: "勇武组", value: 1, time: 1694448000000 },
    { label: "纵横组 ", value: 2, time: 1694793600000 },
    { label: "无极组", value: 3, time: 1695484800000 },
  ],
  3: [
    { label: "勇武组", value: 1, time: 1700888400000 },
    { label: "纵横组 ", value: 2, time: 1700974800000 },
    { label: "无极组", value: 3, time: 1700991000000 },
  ],
  4: [
    { label: "勇武组", value: 1, time: 1706936400000 },
    { label: "纵横组 ", value: 2, time: 1707022800000 },
    { label: "无极组", value: 3, time: 1707039000000 },
  ],
  5: [
    { label: "勇武组", value: 1, time: 1712379600000 },
    { label: "纵横组 ", value: 2, time: 1712466000000 },
    { label: "无极组", value: 3, time: 1712482200000 },
  ],
  6: [
    { label: "勇武组", value: 1, time: 1720242000000 },
    { label: "纵横组 ", value: 2, time: 1720328400000 },
    { label: "无极组", value: 3, time: 1720344600000 },
  ],
  7: [
    { label: "勇武组", value: 1, time: 1730523600000 },
    { label: "纵横组 ", value: 2, time: 1730610000000 },
    { label: "无极组", value: 3, time: 1730626200000 },
  ],
  8: [
    { label: "勇武组", value: 1, time: 1742126400000 },
    { label: "纵横组 ", value: 2, time: 1742619600000 },
    { label: "无极组", value: 3, time: 1742731200000 },
  ],
  9: [
    { label: "勇武组", value: 1, time: 1756641600000 },
    { label: "纵横组 ", value: 2, time: 1757134800000 },
    { label: "无极组", value: 3, time: 1757221200000 },
  ],
  10: [
    { label: "勇武组", value: 1, time: 1764504000000 }, // new Date('2025-11-30 20:00').getTime()
    { label: "纵横组 ", value: 2, time: 1764997200000 }, // new Date('2025-12-6 13:00').getTime()
    { label: "无极组", value: 3, time: 1765083600000 }, // new Date('2025-12-7 13:00').getTime()
  ],
  2025: [
    { label: "勇武组", value: 1, time: 1766725200000 },
    { label: "纵横组 ", value: 2, time: 1766745000000 },
    { label: "无极组", value: 3, time: 1766811600000 },
  ],
  11: [
    { label: "勇武组", value: 1, time: 1774785600000 }, // new Date('2026-3-29 20:00').getTime()
    { label: "纵横组 ", value: 2, time: 1775480400000 }, // new Date('2026-4-11 13:00').getTime()
    { label: "无极组", value: 3, time: 1775480400000 }, // new Date('2026-4-12 13:00').getTime()
  ]
};
